import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { AGENT_SET } from "../../Actions/Kiosk/agentSetAction";
import { AGENT_RESET } from "../../Actions/Kiosk/agentResetAction";
import { storageKeyAgent } from "../../../model/StorageKeys";
import storeState, { emptyState } from '../../../utils/storeState'

export default function agentReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch( action?.type ) {
    case AGENT_SET:
      storeState(storageKeyAgent, action.payload.agent);
      return {
        ...state,
        agent: action.payload.agent
      }
    case AGENT_RESET:
      emptyState(storageKeyAgent);
      return {
        ...state,
        agent: null
      }
    default: 
      return state;
  }
}
